export default __webpack_public_path__ + "static/media/Rastech-update-6-2.cb81c367.jpg";